"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var image_exports = {};
__export(image_exports, {
  blockImages: () => blockImages,
  currentFieldImage: () => currentFieldImage,
  formImages: () => formImages,
  markdownImages: () => markdownImages,
  pageImages: () => pageImages
});
module.exports = __toCommonJS(image_exports);
var import_markdown = require("@cartographerio/markdown");
var import_util = require("@cartographerio/util");
function currentFieldImage(field, value) {
  switch (field.type) {
    case "TextField":
    case "TextArea":
    case "Autocomplete":
    case "IntegerField":
    case "NumberField":
      return field.image;
    case "Select":
      return field.options.find((option) => (option.value ?? null) === (value ?? null))?.image ?? field.image;
    case "MultiSelect":
      return value == null || !Array.isArray(value) ? field.image : field.options.find((option) => value.find((value2) => (option.value ?? null) === (value2 ?? null)))?.image ?? field.image;
    case "Checkbox":
    case "UserRefField":
    case "TimestampField":
    case "AttachmentField":
    case "TeamField":
    case "PointField":
    case "LineStringField":
    case "PolygonField":
    case "FeatureField":
    case "NearestFeatureField":
      return void 0;
    default:
      return (0, import_util.checkExhausted)(field);
  }
}
function markdownImages(markdown) {
  try {
    return markdown == null ? [] : (0, import_markdown.markdownSummary)(markdown).imageUrls;
  } catch (error) {
    return [];
  }
}
function blockImages(block) {
  switch (block.type) {
    case "TextField":
    case "TextArea":
    case "Autocomplete":
    case "IntegerField":
    case "NumberField":
      return [...block.image == null ? [] : [block.image], ...markdownImages(block.help)];
    case "Select":
    case "MultiSelect":
      return [
        ...block.image == null ? [] : [block.image],
        ...(0, import_util.filterAndMap)(block.options, (option) => option.image),
        ...markdownImages(block.help)
      ];
    case "Checkbox":
    case "UserRefField":
    case "TimestampField":
    case "AttachmentField":
    case "LineStringField":
    case "PolygonField":
    case "PointField":
    case "FeatureField":
    case "NearestFeatureField":
    case "DynamicValue":
    case "TeamField":
      return markdownImages(block.help);
    case "Text":
      return markdownImages(block.markdown);
    case "Heading":
    case "DynamicGrid":
    case "PrimarySurveyorField":
    case "PrimaryTeamField":
      return [];
    case "DynamicImage":
      return block.precacheUrls ?? [];
    case "Group":
      return block.blocks.flatMap(blockImages);
    case "Card":
    case "FullWidth":
    case "Repeat":
    case "RequireRole":
    case "Scope":
    case "Visibility":
      return blockImages(block.block);
    default:
      return (0, import_util.checkExhausted)(block);
  }
}
function pageImages(page) {
  return [...markdownImages(page.help), ...page.blocks.flatMap(blockImages)];
}
function formImages(form) {
  return form.pages.flatMap(pageImages);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  blockImages,
  currentFieldImage,
  formImages,
  markdownImages,
  pageImages
});
//# sourceMappingURL=image.js.map
